<template>
  <div class="home-container">
    <!-- 公共头部 -->
    <index-header></index-header>
    <!--轮播图-->
    <div class="home-lunbo">
      <mt-swipe :auto="2000">
        <mt-swipe-item v-for="item in carouselList" :key="item.id">
          <div rel="external nofollow" @click="JumpPage">
            <img :src="imgUrl + item.imgUrl" class="lunboimg" alt=""/>
          </div>
        </mt-swipe-item>
      </mt-swipe>
    </div>

    <div class="home-content">
      <div class="home-edu">
        <div class="title-wrapper">
          <img src="../assets/images/bbs03.png"/>
        </div>
        <div class="edu-wrapper">
          <router-link to="/eduDba">
            <img src="../assets/images/nav-DBA.png" class="nav-img"/>
          </router-link>
          <router-link to="/eduMba">
            <img src="../assets/images/nav-MBA.png" class="nav-img"/>
          </router-link>
          <router-link to="/eduScyx">
            <img src="../assets/images/nav01.png" class="nav-img"/>
          </router-link>
          <router-link to="/eduData">
            <div class="nav-item">教育管理</div>
            <!--						<img src="../assets/images/nav-DATA.png" class="nav-img" />-->
          </router-link>
          <router-link to="/eduApply">
            <img src="../assets/images/nav04.png" class="nav-img"/>
          </router-link>
          <router-link to="/eduFinance">
            <img src="../assets/images/nav-jinrong.png" class="nav-img"/>
          </router-link>
          <router-link to="/eduGjsw">
            <img src="../assets/images/nav08.png" class="nav-img"/>
          </router-link>
          <router-link to="/eduManger">
            <img src="../assets/images/nav-number.png" class="nav-img"/>
          </router-link>
          <router-link to="/eduDzsw">
            <img src="../assets/images/nav03.png" class="nav-img"/>
          </router-link>
        </div>
        <div style="clear: both;"></div>
      </div>
      <!-- 新闻列表 -->
      <div class="home-news">
        <div class="title-wrapper">
          <img src="../assets/images/bbs04.png"/>
        </div>
        <div class="news-wrapper">
          <ul class="news-item">
            <li class="item" v-for="item of newsInfolist" :key="item.cmsId">
              <router-link :to="{path: '/newsDetails', query: {cmsId:item.cmsId }}">
                <div class="item-img-wrapper">
                  <img :src="ImgUrl+item.cmsIco+'&type=thumb'" class="item-image"/>
                </div>
                <div class="item-info">
                  <p class="item-title">{{ item.cmsTitle }}</p>
                  <p class="item-time">{{ item.createTime|dateFmt('YYYY-MM-DD') }}</p>
                </div>
              </router-link>
            </li>
          </ul>
          <div class="newsmore">
            <router-link to="/NewsList">更多新闻</router-link>
          </div>
        </div>

      </div>
      <!-- 新闻列表 -->
      <!-- 校友风采 -->
      <div class="home-alumni">
        <AlumniStyle />
      </div>
      <!-- 校友风采 -->
    </div>
    <!--数据bbs-->
    <div class="home-bbs">
      <div class="title-wrapper">
        <img src="../assets/images/bbs01.png"/>
      </div>
      <div class="bbs-wrapper">
        <ul class="bbs-item">
          <li>
            <img src="../assets/images/56.png" class="BbsImg"/>
          </li>
          <li>
            <img src="../assets/images/1.png" class="BbsImg"/>
          </li>
          <li>
            <img src="../assets/images/11.png" class="BbsImg"/>
          </li>
          <li>
            <img src="../assets/images/3.png" class="BbsImg"/>
          </li>
          <li>
            <img src="../assets/images/22.png" class="BbsImg"/>
          </li>
          <li>
            <img src="../assets/images/35.png" class="BbsImg"/>
          </li>
          <li>
            <img src="../assets/images/50.png" class="BbsImg"/>
          </li>
          <li>
            <img src="../assets/images/35000.png" class="BbsImg"/>
          </li>
        </ul>
      </div>
    </div>
    <!--教学中心-->
    <div class="home-teacher">
      <div class="title-wrapper">
        <img src="../assets/images/bbs02.png"/>
      </div>
      <div class="map">
        <img src="../assets/images/map.png"/>
        <div class="teacher-wrapper">
          <!-- <span class="teacher">
                         <span class="c2">北京海淀区教学中心</span> 鲁老师 13366026804
          </span>  -->
          <!--<span  class="teacher">
                         <span class="c2">上海市浦东区教学中心</span> 张老师 18012783327
           </span>-->
        </div>
      </div>
    </div>
    <!--教学中心结束-->
    <home-footer></home-footer>
  </div>
</template>
<script>
import {Swipe, SwipeItem} from "mint-ui";
import {portalBannerList} from "@/apis/apis"
import "mint-ui/lib/style.css";
import {getList} from "../apis/apis.js";
import HomeFooter from "../components/homeFooter";
import IndexHeader from "../components/indexHeader";
import AlumniStyle from "./components/AlumniStyle.vue";
export default {
  name: "Home",
  components: {
    "mt-swipe": Swipe,
    "mt-swipe-item": SwipeItem,
    HomeFooter,
    IndexHeader,
    AlumniStyle
  },
  data() {
    return {
      imgUrl: "//media.yzvet.com/",
      //				keywords: "布雷斯特高等商学院，法国布雷斯特高等商学院，布雷斯特，工商管理硕士，工商管理博士，教育，在职研究生，学历",
      //				description: "布雷斯特高等商学院，法国高等精英商学院！布雷斯特高等商学院，教育学位得到全球认可的欧洲名校！中国教育部监管网公布的正规院校！国际商务管理教育排名第一的名校！法国总统总理鼎力支持的欧洲名校！",
      carouselList: [],
      ImgUrl: "http://file.hainayx.com/file-server/download?fileUrl=",
      newsInfolist: [{
        cmsId: "",
        cmsIco: "",
        createTime: "",
        cmsTitle: ""
      }]
    };
  },
  methods: {
    // 获取轮播图数据
    async getPortalBanner() {
      let params = {
        pageSize: 1000,
        pageNum: 1,
      };
      try {
        let {data} = await portalBannerList(params);
        if (data.code === 1000) {
          this.carouselList = data.data;
        } else {
        }
      } catch (err) {
        console.log("服务器异常", err);
      }
    },
    async getList() {
      let params = {
        pageSize: "3",
        pageNum: "1",
        cmsCategory: "2",
      };
      try {
        let {
          data
        } = await getList(params);
        this.newsInfolist = data.data.content;
      } catch (err) {
      }
    },
    JumpPage(item) {
      if (item.link) {
        window.open(item.link, '_blank');
      }
    },
  },
  mounted() {
    this.getList();
    this.getPortalBanner();
  }
};
</script>
<style scoped>
/* // 轮播图样式 */

.lunboimg {
  width: 100%;
  height: 400px;

}
/deep/ .mint-swipe-item {
  width: 100%;
}
/deep/ .mint-swipe-item img{
  object-fit: cover;
}

/deep/.mint-swipe {
  width: 100%;
  height: 400px;
}

/deep/ .mint-swipe-indicator {
  background: #fff;
}

/deep/ .mint-swipe-indicator.is-active {
  background: #e58111;
}

/deep/ .mint-swipe-indicator {
  width: 0.4rem;
  height: 0.1rem;
  border-radius: 0;
  margin-left: 0.2rem;
}

/deep/ .mint-swipe-indicators {
  bottom: 0.6rem;
}

/* 中间部分样式 */

.home-content {
  width: 100%;
  height: 100%;
  padding: 30px 0;
  background: url("../assets/images/nav-banner.jpg") no-repeat;
  background-size: 100% 100%;
}

/* title */

.title-wrapper {
  width: 95%;
  margin: 0 auto;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 47px;
}

.title-wrapper img {
  width: 301px;
  height: 100%;
}

/* // nav样式 */

.home-edu {
  width: 100%;
  overflow: hidden;
}

.edu-wrapper {
  width: 95%;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

/*.edu-wrapper p {
  display: inline-block;
  width: 112px;
  height: 113px;
  margin-right: 79.5px;
  margin-bottom: 20px;
}
*/

.edu-wrapper a {
  display: inline-block;
  /*float: left;*/
  width: 33%;
  overflow: hidden;
  margin-bottom: 0.2rem;
  text-align: center;
}

.nav-img {
  width: 130px;
  height: 130px;
}

.nav-item {
  width: 130px;
  height: 130px;
  line-height: 130px;
  display: inline-block;
  background: #e58111;
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
}

.t4 {
  margin-right: 0px !important;
}

.home-news {
  width: 100%;
  height: auto;
}

/* 新闻列表样式 */

.item-wrapper {
  width: 100%;
}

.news-item {
  width: 95%;
  margin: 0 auto;
}

.item {
  height: 200px;
  border-bottom: 1px solid #ccc;
}

.item-img-wrapper {
  width: 228px;
  height: 150px;
  display: inline-block;
  margin-top: 26px;
  overflow: hidden;
}

.item-image {
  width: 228px;
  height: 100%;
  object-fit: cover;

}

.item-info {
  width: 60%;
  float: right;
  margin-top: 30px;
}

.item-title {
  font-size: 29px;
  color: rgba(51, 51, 51, 1);
  line-height: 46px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 95px;
}

.item-time {
  font-size: 24px;
  color: #999;
  line-height: 55px;
}

/* 更多新闻 */

.newsmore {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 33px;
}

.newsmore a {
  border: 3px solid rgba(229, 129, 17, 1);
  color: #e58111;
  padding: 7px 5px;
  border-radius: 6px;
  font-size: 26px;
  display: inline-block;
}

/* 教育项目*/

.home-bbs {
  width: 100%;
  height: 1000px;
  background: url("../assets/images/hone-bbs.png") no-repeat;
  background-size: 100% 100%;
}

.bbs-wrapper {
  width: 85%;
  margin: 0 auto;
}

.bbs-item {
  width: 100%;
}

.bbs-item li {
  float: left;
  width: 50%;
}

.BbsImg {
  width: 280px;
  height: 170px;
  margin-bottom: 31px;
}

.bbs-item li:nth-child(2n) {
  text-align: right;
}

/* 教学中心样式 */

.home-teacher {
  width: 100%;
  height: 755px;
  background-size: 100% 100%;
  background: #eaeaea;
}

.teacher-wrapper {
  margin-top: 10px;
}

.map {
  width: 85%;
  margin: 0 auto;
}

.map img {
  width: 665px;
  height: auto;
}

.teacher {
  display: block;
  line-height: 40px;
  color: #3a3a3a;
  font-size: 24px;
  letter-spacing: 1px;
}

.c2 {
  width: 40%;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue